module.exports = __webpack_public_path__ + "static/media/menosphliquido.7917f249.pdf";